import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { map, shareReplay, tap } from 'rxjs/operators'
import { JmeleonActionsForRightService } from '../modules/permissions'
import { SettingsService } from '../modules/settings'
import { BrowserStorageService } from './browser-storage.service'
import { CatalogueService } from './catalogue.service'

/**
 *
 *
 */
@Injectable({
  providedIn: 'root'
})
export class LocalBackendMiscDataStorageService {
  constructor(
    private browserStorage: BrowserStorageService,
    private roleService: JmeleonActionsForRightService
  ) {}

  getMasterOfDisasterId = (): Observable<number> => {
    if (this.browserStorage.hasMasterOfDisasterRightId) {
      return of(this.browserStorage.masterOfDisasterRightId)
    }
    return this.roleService.getMasterRole().pipe(
      map((masterRole) => masterRole.id),
      shareReplay(1)
    )
  }
}
